import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'controlador-trade');

const controladorTradeActions = {
  listar: { method: 'GET', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, controladorTradeActions);
